export default __webpack_public_path__ + "static/media/ding.4bf3338b.mp3";